document.addEventListener("DOMContentLoaded", () => {

  const shopSuffix = " - Flawless Vape Shop";

  function updateAltFromVariant(variant) {
    if (!variant) return;

    const productTitle =
      document.querySelector("h1.product__title, h1")?.textContent?.trim();

    if (!productTitle) return;

    let finalAlt = productTitle;

    if (variant.title && variant.title !== "Default Title") {
      finalAlt += ` - ${variant.title}`;
    }

    finalAlt += shopSuffix;

    document
      .querySelectorAll(".thumbnail img, .product__media img")
      .forEach(img => {
        img.alt = finalAlt;
      });
  }

  // 1️⃣ Get initial variant (Dawn/Trade safe way)
  function getInitialVariant() {
    const productForm = document.querySelector('product-form');

    if (!productForm) return null;

    return productForm.variant || null;
  }

  // 2️⃣ Run once after small delay (ensures variant exists)
  setTimeout(() => {
    const initialVariant = getInitialVariant();
    updateAltFromVariant(initialVariant);
  }, 500);

  // 3️⃣ Listen for variant changes (OS 2.0 event)
  document.addEventListener("variant:change", (event) => {
    if (!event.detail?.variant) return;
    updateAltFromVariant(event.detail.variant);
  });

});